module.exports = __webpack_public_path__ + "img/shouji.118e43f6.svg";